function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { noop } from "lodash";
import RoundNotification from "../../RoundNotification";
import Tooltip from "../../Tooltip";
import ButtonLoader from "../styles/ButtonLoader.js";
import DropdownButton from "../styles/DropdownButton.js";
import IconButton from "../styles/IconButton.js";
import PrimaryButton from "../styles/PrimaryButton.js";
import SecondaryButton from "../styles/SecondaryButton.js";
import StyledImage from "../styles/StyledImage.js";
import TertiaryButton from "../styles/TertiaryButton.js";
import ToggleButton from "../styles/ToggleButton.js";
import UpgradeButton from "../styles/UpgradeButton.js";
class Button extends React.Component {
    render() {
        const _this_props = this.props, { children, className, 'data-testid': dataTestId, 'data-testid-loader': dataTestIdLoader, deletion, disabled, icon: Icon, image, isLoading, locator, mode, notif, _ref, selected, small, tooltip } = _this_props, rest = _object_without_properties_loose(_this_props, [
            "children",
            "className",
            'data-testid',
            'data-testid-loader',
            "deletion",
            "disabled",
            "icon",
            "image",
            "isLoading",
            "locator",
            "mode",
            "notif",
            "_ref",
            "selected",
            "small",
            "tooltip"
        ]);
        const realIsLoading = isLoading && !disabled;
        let realChildren;
        switch(mode){
            case 'icon':
                realChildren = /*#__PURE__*/ React.createElement(React.Fragment, null, Icon && !image && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
                    key: "icon"
                }), notif && /*#__PURE__*/ React.createElement(RoundNotification, {
                    color: notif.color,
                    type: notif.type
                })), image && /*#__PURE__*/ React.createElement(StyledImage, {
                    mt: "-4px"
                }, image), children && children);
                break;
            case 'tertiary':
                realChildren = /*#__PURE__*/ React.createElement(React.Fragment, null, Icon && !image && /*#__PURE__*/ React.createElement(Icon, {
                    mr: "s3",
                    size: "s3"
                }), image && /*#__PURE__*/ React.createElement(StyledImage, {
                    mt: "0"
                }, image), children);
                break;
            default:
                realChildren = children;
                break;
        }
        const content = /*#__PURE__*/ React.createElement(React.Fragment, null, realIsLoading && /*#__PURE__*/ React.createElement(ButtonLoader, {
            "data-testid": dataTestIdLoader,
            size: "s4"
        }), realChildren);
        const newClassNames = cx(className, locator, {
            'is-disabled': disabled,
            'is-loading': realIsLoading,
            'is-selected': selected
        });
        let s = /*#__PURE__*/ React.createElement(PrimaryButton, {
            deletion: deletion
        }, content);
        switch(mode){
            case 'dropdown':
                s = /*#__PURE__*/ React.createElement(DropdownButton, null, content);
                break;
            case 'icon':
                s = /*#__PURE__*/ React.createElement(IconButton, {
                    as: "button",
                    deletion: deletion,
                    disabled: disabled,
                    isLoading: isLoading
                }, content);
                break;
            case 'secondary':
                s = /*#__PURE__*/ React.createElement(SecondaryButton, null, content);
                break;
            case 'tertiary':
                s = /*#__PURE__*/ React.createElement(TertiaryButton, null, content);
                break;
            case 'toggle':
                s = /*#__PURE__*/ React.createElement(ToggleButton, null, content);
                break;
            case 'upgrade':
                s = /*#__PURE__*/ React.createElement(UpgradeButton, null, content);
                break;
        }
        const realOnClick = disabled || isLoading ? noop : this.onClick;
        const clonedElement = /*#__PURE__*/ React.cloneElement(s, _extends({}, rest, {
            className: newClassNames,
            'data-testid': dataTestId,
            disabled,
            onClick: realOnClick,
            ref: _ref,
            $small: small
        }));
        if (tooltip) {
            return /*#__PURE__*/ React.createElement(Tooltip, {
                direction: tooltip.direction || 'top',
                message: tooltip.message || ''
            }, clonedElement);
        }
        return clonedElement;
    }
    constructor(...args){
        super(...args);
        this.onClick = (e)=>{
            const { noFocus, onClick } = this.props;
            noFocus && document.activeElement && document.activeElement.blur();
            onClick && onClick(e);
        };
    }
}
Button.defaultProps = {
    mode: 'primary',
    neutral: false,
    onClick: noop,
    outlineDark: false,
    type: 'button'
};
Button.propTypes = {
    _ref: PropTypes.oneOfType([
        PropTypes.func,
        typeof Element !== 'undefined' ? PropTypes.shape({
            current: PropTypes.instanceOf(Element)
        }) : PropTypes.any
    ]),
    className: PropTypes.string,
    'data-testid': PropTypes.string,
    'data-testid-loader': PropTypes.string,
    deletion: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.elementType,
    image: PropTypes.node,
    isLoading: PropTypes.bool,
    locator: PropTypes.string,
    mode: PropTypes.oneOf([
        'dropdown',
        'icon',
        'primary',
        'secondary',
        'tertiary',
        'toggle',
        'upgrade'
    ]),
    neutral: PropTypes.bool,
    noFocus: PropTypes.bool,
    notif: PropTypes.shape({
        color: PropTypes.string,
        type: PropTypes.string
    }),
    onClick: PropTypes.func,
    outlineDark: PropTypes.bool,
    selected: PropTypes.bool,
    small: PropTypes.bool,
    style: PropTypes.object,
    tooltip: PropTypes.shape({
        direction: PropTypes.string,
        message: PropTypes.string
    }),
    type: PropTypes.string
};
export default Button;
